import React, { InputHTMLAttributes } from 'react';

import './ColorPicker.scss';

const ColorPicker: React.FC<InputHTMLAttributes<HTMLInputElement>> = props => {
	return (
		<input
			type='color'
			{...props}
			className={`color-picker ${props.className}`}
		/>
	);
};

export default ColorPicker;
